import {
  checkIcon,
  ClarityIcons,
  copyIcon,
  cursorHandClickIcon,
  eyeIcon,
  fileGroupIcon,
  filterIcon,
  layersIcon,
  lockIcon,
  searchIcon,
  syncIcon,
  timesIcon,
} from '@cds/core/icon';

// Icons of the apps groups page that the main component does not register
ClarityIcons.addIcons(checkIcon, copyIcon, cursorHandClickIcon, eyeIcon, fileGroupIcon, filterIcon, layersIcon,
  lockIcon, searchIcon, syncIcon, timesIcon);
